import React, { useState, useEffect } from "react";
import { Button, Search, Table, IconDownload, ConfirmationModal } from "@veneer/core";

const ApprovalConfirmationModal = ({ onHideModel, isModalShowing, data, status, setidSC }) => {
    const [modalState, setModalState] = useState({ isModalShowing });
    let text = "";
    let ids = '';
    if (data) {
        if (data.length <= 1) {
            text = 'was';
            ids = 'Id: ';
        } else {
            text = 'were';
            ids = 'Ids: ';
        }
    }
    const approving = () => {
        if(status == 'Extended') setidSC(1);
        onHideModel();
    }

    return (
        <>
            <ConfirmationModal
                id="confirmation-modal2"
                onConfirm={approving}
                onClose={approving}
                show={isModalShowing}
                title="Special Conditions result"
            >
                
                <p>
                    {data.length > 0 ?
                        'Success! Special condition '+ ids + data.join(', ') +' ' +text +' '
                        : ''}
                    <b>{status}</b>.
                </p>

            </ConfirmationModal>
            
        </>
        );
}
ApprovalConfirmationModal.defaultProps = {
    data: '',
    isModalShowing: false,
}
export default ApprovalConfirmationModal